<template>
  <v-container class="main-container sn-shadow-depth-02">
    <v-row class="d-flex flex-nowrap justify-center">
      <phone-mock
        class="phone-mock mt-md-16 mt-lg-0"
        :servicer="servicer"
      />
      <section class="go-mobile-text">
        <h1 class="sn-h1 sn-text-primary-03">
          Want to go mobile?
        </h1>
        <p
          class="left-highlight sn-body-1"
          :style="`border-left: 4px solid ${this.$vuetify.theme.themes.dark.primary}`"
        >
          Download the app for even more features like secure mobile document scanning and instant notifications.
        </p>
        <ul class="list mt-6 pl-1 sn-body-1">
          <li>
            <v-icon
              class="mr-3"
              size="24"
              :color="$vuetify.theme.themes.dark.primary"
            >
              sn-icon-check-circle
            </v-icon>
            Securely scan &amp; upload docs from your phone
          </li>
          <li class="mt-7">
            <v-icon
              class="mr-3"
              size="24"
              :color="$vuetify.theme.themes.dark.primary"
            >
              sn-icon-check-circle
            </v-icon>
            Live updates as you go
          </li>
          <li class="mt-7">
            <v-icon
              class="mr-3"
              size="24"
              :color="$vuetify.theme.themes.dark.primary"
            >
              sn-icon-check-circle
            </v-icon>
            Message your loan officer instantly
          </li>
        </ul>
        <action-input
          label-text="Enter your mobile number"
          button-text="Send me the app"
          type="phone"
          :rules="phoneRules"
          @action-btn-clicked="sendSMS"
        />
        <p class="sn-caption sn-text-primary-01">
          Some restrictions may apply. Message and data rates may apply from your data carrier.
        </p>
      </section>
    </v-row>
  </v-container>
</template>

<script>
import ActionInput from '../Form/ActionTextInput.vue'
import PhoneMock from './PhoneMock.vue'
import snUtilService from '~/services/snUtilService.js'

export default {
  components: {
    ActionInput,
    PhoneMock
  },
  props: {
    servicer: {
      type: Object,
      required: true,
      default: () => { return {} }
    }
  },
  data () {
    return {
      loading: false,
      phoneRules: [
        v => /^(\(?\d{3}\)?-?\d{3}-?\d{4}|\(?\d{3}\)?.?\d{3}.?\d{4}|\d{10})$/.test(v) || 'Please enter a valid phone number'
      ]
    }
  },
  methods: {
    sendSMS (inputText) {
      const code = window.location.pathname.split('/')[3]
      this.loading = true
      this.$snackbard.loading({ text: 'Sending text message.' })
      if (inputText) {
        snUtilService.shareAppBySms(inputText.replace(/\D/g, ''), code)
          .then(() => {
            this.$emit('input', false)
            this.loading = false
            this.$snackbard.cancel({ text: 'Message sent.' })
            // this.$snackbard.success({ text: 'Message sent' })
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~/assets/css/snui';

  .main-container {
    padding: 0 55px;
  }
  .phone-mock {
    box-shadow: $sn-shadow-depth-2;
  }
  .go-mobile-text {
    position: relative;
    margin-top: 55px;
    margin-left: 80px;
  }
  .left-highlight {
    padding-left: 12px;
    margin-top: 21px;
  }
  .list {
    list-style: none;
    margin-bottom: 25px;
  }
</style>
